//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'formDialog',
  data () {
    return {
      dialogTitle:"岗位信息",
      dialogVisible: false
    }
  },
  methods:{
    open(){
      this.dialogVisible = true
    },
    close(){
      this.dialogVisible = false
    },
    closed(){

    },

  }
}



// WEBPACK FOOTER //
// ./src/components/tableUnit/components/formDialog.vue